import { FF_PPP_TESTING } from '@/constants/featureFlags';
import type { PCPUserData } from '@/constants/pcp/types';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { useLocation } from 'react-router-dom';
import type { PCPPage } from '../constants/types';
import { initialTestingPage, initialTestingUserData } from '../content/testingData';

export default function useTesting(): [boolean | undefined, PCPUserData, PCPPage, boolean] {
  const { flags } = useFeatureFlags();
  const pcpTestingEnabled = flags[FF_PPP_TESTING];
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const testQueryParam = queryParams.get('test');
  const testingRequested = typeof testQueryParam === 'string';

  let testing: boolean | undefined = false;
  if (pcpTestingEnabled) {
    testing = testingRequested;
  }

  return [testing, initialTestingUserData, initialTestingPage, pcpTestingEnabled];
}
